import { Component } from '@theme/component';
import { lockScroll, unlockScroll } from '@theme/utilities';

const STORAGE_KEY = 'script-entered';

/**
 * Full-screen splash shown once per visit. Clicking the button fades it out
 * and remembers the choice for the rest of the browser session.
 * @extends {Component}
 */
class EnterScreen extends Component {
  connectedCallback() {
    super.connectedCallback();

    if (this.hasAttribute('data-design-mode')) return;

    if (this.#hasEntered()) {
      this.remove();
      return;
    }

    lockScroll(this);

    const button = this.refs.button;
    if (button instanceof HTMLElement) button.focus({ preventScroll: true, focusVisible: false });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    unlockScroll(this);
  }

  enter() {
    if (this.hasAttribute('data-design-mode')) return;

    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch (error) {
      // Storage can be blocked (private mode, strict settings); the screen still closes.
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      this.remove();
      return;
    }

    this.classList.add('enter-screen--leaving');
    this.addEventListener('transitionend', () => this.remove(), { once: true });
    // Fallback in case transitionend never fires.
    setTimeout(() => this.isConnected && this.remove(), 800);
  }

  #hasEntered() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) !== null;
    } catch (error) {
      return false;
    }
  }
}

if (!customElements.get('enter-screen')) {
  customElements.define('enter-screen', EnterScreen);
}
